import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from '../views/manager/Admin.vue'
import Notice from '../views/manager/Notice.vue'
import Banner from '../views/manager/Banner.vue'
import PhotoCategory from '../views/manager/PhotoCategory.vue'
import PhotoSeries from '../views/manager/PhotoSeries.vue'
import Photo from '../views/manager/Photo.vue'
import PricePackage from '../views/manager/PricePackage.vue'
import StudioInfo from '../views/manager/StudioInfo.vue'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/manager/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'manager/home', name: 'MHome', component: () => import('../views/manager/Home'), meta: { requireAuth: true } },
      { path: 'manager/admin', name: 'MAdmin', component: Admin, meta: { requireAuth: true } },
      { path: 'manager/adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'manager/password', name: 'MPassword', component: () => import('../views/manager/Password'), meta: { requireAuth: true } },
      { path: 'manager/notice', name: 'MNotice', component: Notice, meta: { requireAuth: true } },
      { path: 'manager/person', name: 'MPerson', component: () => import('../views/manager/AdminPerson'), meta: { requireAuth: true } },
      { path: 'manager/banner', name: 'MBanner', component: () => import('../views/manager/Banner'), meta: { requireAuth: true } },
      { path: 'manager/category', name: 'MCategory', component: () => import('../views/manager/PhotoCategory'), meta: { requireAuth: true } },
      { path: 'manager/series', name: 'MSeries', component: () => import('../views/manager/PhotoSeries'), meta: { requireAuth: true } },
      { path: 'manager/photo', name: 'MPhoto', component: () => import('../views/manager/Photo'), meta: { requireAuth: true } },
      { path: 'manager/package', name: 'MPackage', component: () => import('../views/manager/PricePackage'), meta: { requireAuth: true } },
      { path: 'manager/studio', name: 'MStudio', component: () => import('../views/manager/StudioInfo'), meta: { requireAuth: true } },
      { path: 'manager/home-config', name: 'MHomeConfig', component: () => import('../views/manager/HomeConfig'), meta: { requireAuth: true } },
      { path: 'manager/home-series', name: 'MHomeSeries', component: () => import('../views/manager/HomeSeries'), meta: { requireAuth: true } },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Manager.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
